/*
  Project: Hausarzt Münster
  Author: Luum GmbH
 */

import '../../node_modules/foundation-sites/dist/js/foundation';
import main from './modules/main';

const $ = require('jquery');

main();
$(document).foundation();



// WEBPACK FOOTER //
// ./src/scripts/app.js